export default __webpack_public_path__ + "static/media/Ajustes (Real Size).6adbb550.svg";